import { render, staticRenderFns } from "./JunkHistoryList.vue?vue&type=template&id=26ef851e&"
import script from "./JunkHistoryList.vue?vue&type=script&lang=js&"
export * from "./JunkHistoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports